import { Component, EventEmitter, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import { TourService } from 'src/app/api/tourism/tour.service';
import { ToolsService } from 'src/app/utils/tools.service';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-gallery-tourism',
  templateUrl: './gallery-tourism.component.html',
  styleUrls: ['./gallery-tourism.component.css']
})
export class GalleryTourismComponent {
  @Output() onselectedGalleryEvent = new EventEmitter<string>();

  tabs = ['Tours', 'Hoteles'];
  activeTab = 0;

  // items = [
  //   { id: 1, name: 'Item 1' },
  //   { id: 2, name: 'Item 2' },
  //   { id: 3, name: 'Item 3' }
  // ];
  // selectedItem: any = 3;

  // TOURS
  tours: any = [];
  tours_temp: any = [];
  selectedTour: any;
  img_tours: any = [];
  arr_checkeds: any = [];

  // HOTEL
  hotels: any = [];
  hotels_temp: any = [];
  selectedHotel: any;
  img_hotels: any = [];

  count_selecteds: number = 0;

  constructor(
    private tourService: TourService,
    private hotelService: HotelService,
    private alertifyMsg: AlertifyHelper,
    private toolsService: ToolsService
  ) {}

  changeTab(index: number): void {
    this.activeTab = index;
    this.resetForm();
    // if (this.activeTab == 1) {
    //   this.resetForm();
    //   this.loadDataHotels();
    // }
    // else{
    //   this.loadData();
    // }
  }

  loadData() {
    this.tourService.all().subscribe({
      next: (data: any) => {
        for (let i in data) {
          data[i].checked = false;
        }
        this.tours = data;
        this.tours_temp = this.tours;
      }
    });

    this.hotelService.all().subscribe({
      next: (data: any) => {
        let data_ = data.results;
        for (let i in data_) {
          data_[i].checked = false;
        }
        this.hotels = data_;
        this.hotels_temp = this.hotels;
      }
    });
  }

  loadDataHotels() {
    this.hotelService.all().subscribe({
      next: (data: any) => {
        let data_ = data.results;
        for (let i in data_) {
          data_[i].checked = false;
        }
        this.hotels = data_;
      }
    });

  }

  changeChecked() {
    for (let i in this.img_tours) {
      if (this.img_tours[i].checked == true) {
        for (let j in this.arr_checkeds) {
          if (this.arr_checkeds[j].id == this.img_tours[i].tours_id) {
            if (
              this.toolsService.notExistObjInArr(
                this.img_tours[i],
                this.arr_checkeds[j].detail_img
              )
            ) {
              this.arr_checkeds[j].detail_img.push(this.img_tours[i]);
              this.count_selecteds = this.count_selecteds + 1;
            }
          }
        }
      } else {
        for (let j in this.arr_checkeds) {
          if (this.arr_checkeds[j].id == this.img_tours[i].tours_id) {
            if (
              !this.toolsService.notExistObjInArr(
                this.img_tours[i],
                this.arr_checkeds[j].detail_img
              )
            ) {
              this.arr_checkeds[j].detail_img.splice(i, 1);
              this.count_selecteds = this.count_selecteds - 1;
            }
          }
        }
      }
    }

    // this.arr_checkeds = [];
    // for (let i in this.img_tours) {
    //   if (this.img_tours[i].checked == true) {
    //     if( this.toolsService.notExistObjInArr(this.img_tours[i], this.arr_checkeds)){
    //       this.arr_checkeds.push(this.img_tours[i]);
    //     }
    //   }
    // }
  }

  getImgTour() {
    this.img_tours = this.selectedTour.gallery_image_str;

    let tour_ = this.selectedTour;
    if (this.toolsService.notExistObjInArr(tour_, this.arr_checkeds)) {
      tour_.id = this.selectedTour.id;
      tour_.detail_img = [];
      this.arr_checkeds.push(tour_);
    }
  }

  getImgHotel() {
    this.img_hotels = this.selectedHotel.gallery_image_str;

    let hotel_ = this.selectedHotel;
    if (this.toolsService.notExistObjInArr(hotel_, this.arr_checkeds)) {
      hotel_.id = this.selectedHotel.id;
      hotel_.detail_img = [];
      this.arr_checkeds.push(hotel_);
    }
  }

  changeCheckedHotel() {
    for (let i in this.img_hotels) {
      if (this.img_hotels[i].checked == true) {
        for (let j in this.arr_checkeds) {
          if (this.arr_checkeds[j].id == this.img_hotels[i].hotels_id) {
            if (
              this.toolsService.notExistObjInArr(
                this.img_hotels[i],
                this.arr_checkeds[j].detail_img
              )
            ) {
              this.arr_checkeds[j].detail_img.push(this.img_hotels[i]);
              this.count_selecteds = this.count_selecteds + 1;
            }
          }
        }
      } else {
        for (let j in this.arr_checkeds) {
          if (this.arr_checkeds[j].id == this.img_hotels[i].hotels_id) {
            if (
              !this.toolsService.notExistObjInArr(
                this.img_hotels[i],
                this.arr_checkeds[j].detail_img
              )
            ) {
              this.arr_checkeds[j].detail_img.splice(i, 1);
              this.count_selecteds = this.count_selecteds - 1;
            }
          }
        }
      }
    }
  }

  addSelecteds() {
    let data_: any = [];
    for (let i in this.arr_checkeds) {
      for (let j in this.arr_checkeds[i].detail_img) {
        data_.push(this.arr_checkeds[i].detail_img[j]);
      }
    }

    if (data_.length > 0) {
      this.onselectedGalleryEvent.emit(data_);
      this.close();
      (<any>$('#openExtendsGalleryTourism')).modal('hide');
    } else {
      this.alertifyMsg.warning('Debe seleccionar almenos una imágen');
    }
  }

  resetForm() {
    this.tours = this.tours_temp;
    this.selectedTour = null;
    this.img_tours = [];
    // hotels =====
    this.hotels = this.hotels_temp;
    this.selectedHotel = null;
    this.img_hotels = [];

    this.arr_checkeds = [];
    this.count_selecteds = 0;
  }

  close() {
    this.activeTab = 0;
    this.resetForm();
  }
}
